import { useQueryGetUserMilestones } from '@ifit/gateway-wolf-athenaeum-service';
import Loading from '@ifit/mary-poppins/dist/Loading';
import React from 'react';
import { isMobile } from '../../../../helpers';
import {
  milestonesInfoText,
  milestonesTitle,
  milestonesWorkoutsCompleted,
} from '../../../../i18n/translations';
import { useConfig } from '../../../../store/reducers/config';
import './index.scss';
import MilestonesCards from './milestones-cards';
import { useMembership } from '../../../../client/query/users';

export interface IWorkoutsCompleted {
  workoutsCompleted: number | undefined | null; // undefined = loading, null = error
}

const MilestonesInfo: React.FC<IWorkoutsCompleted> = ({
  workoutsCompleted,
}: IWorkoutsCompleted) => {
  const { isGuest } = useConfig();
  return (
    <div className="info">
      <h1>{milestonesTitle()}</h1>
      {!isGuest && workoutsCompleted !== null && (
        <>
          <h2>{milestonesWorkoutsCompleted()}</h2>
          {workoutsCompleted !== undefined ? (
            <h3>{workoutsCompleted}</h3>
          ) : (
            <span
              className="loading-container"
              data-testid="milestones-loading"
            >
              <Loading absolute />
            </span>
          )}
        </>
      )}
      <p dangerouslySetInnerHTML={{ __html: milestonesInfoText() }} />
    </div>
  );
};

const MilestonesRow: React.FC = () => {
  const { deviceType } = useConfig();
  const { isFreeLibrary } = useMembership();
  const { data, isLoading, isError } = useQueryGetUserMilestones(
    {},
    {
      enabled: isFreeLibrary === false,
    },
  );
  const workoutsCompleted = isError
    ? null
    : isLoading
    ? undefined
    : data?.countYTD;
  return isFreeLibrary ? null : (
    <div className="milestones-row">
      <MilestonesInfo workoutsCompleted={workoutsCompleted} />
      <MilestonesCards
        workoutsCompleted={workoutsCompleted}
        isMobile={isMobile(deviceType)}
      />
    </div>
  );
};

export default MilestonesRow;
